import { createIcon } from "@chakra-ui/react";

export const LinkIcon = createIcon({
  displayName: "LinkIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M5 4.667h-.333a3.333 3.333 0 000 6.666H6A3.333 3.333 0 009.333 8M11 11.333h.333a3.333 3.333 0 100-6.666H10A3.333 3.333 0 006.667 8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "16px",
    height: "16px",
  },
});
